class StatBar extends PIXI.Container {

	static textStyle = new PIXI.TextStyle({
		fontFamily: 'courier',
		fontStyle: 'bold',
		fontSize: '20px',
		fill: 0xffffff
	});


	public mobHash: { [name: string]: number } = {};
	public money: number;

	public counters: Array<PIXI.Text> = [];

	public createCounters(): void {
		App.stage.addChild(this);

		this.addChild(new PIXI.Sprite(Assets.ui.panel_top));
		this.position.set(5, 5);

		for (let i = 0; i < 5; i++) {
			this.counters.push(new PIXI.Text("0", StatBar.textStyle));
			this.counters[i].pivot.y = 10;
		}

		let dx = 20, dx2 = 154;

		let x = 40, y = Assets.ui.panel_top.height / 2;

		let icons = [Assets.ui.rabbit_icon, Assets.ui.bear_icon, Assets.ui.pony_icon, Assets.ui.kps_icon, Assets.ui.money_icon];

		for (let i = 0; i < 5; i++) {
			let elem = new PIXI.Sprite(icons[i]);
			centerFrickingSprite(elem);
			elem.position.set(x, y);
			this.addChild(elem);
			x += dx;
			elem = this.counters[i];
			elem.position.set(x, y);
			this.addChild(elem);
			x += dx2;
		}
	}

	public update(): void {
		this.counters[0].text = (this.mobHash['rabbit']||0) + "";
		this.counters[1].text = (this.mobHash['bear']||0) + "";
		this.counters[2].text = (this.mobHash['pony']||0) + "";
		this.counters[3].text = Game.worldController.getKps(Game.millisecondsAbsolute) + "";
		this.counters[4].text = this.money + "";
		for (let i = 0; i < 5; i++) {
			(this.counters[i] as any).updateText(true);
		}
	}

	public enemyKilled(mob: Mob): void {
		let count = (this.mobHash[mob.name] || 0) + 1;
		this.mobHash[mob.name] = count;
		this.money += mob.price;
	}
}